<template lang="pug">
  div.error
    top-nav(headerColor="white")
    .content
      .grid
        .col-3_xs-12
          .title
            h1.h-xl
              | Sorry, we couldn't find the page you were looking for!
            h2.h-sm.bold
              | Error code: 404 </br>
        .col-9_xs-12
          img.cover(src="/static/images/404_image.jpg" alt="page not found 404")
          p.message.body
            | You can go back to the page that brought you here, or you can look for the page you want using our site search.
    bottom-nav(footerColor="white")
</template>

<script>
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'error',
  mixins: [ComponentMixin]
}
</script>

<style lang="sass">
  @import '../styles/_variables'
  .error
    .content
      .title
        margin-top: $paddingTop
        h2
          padding-top: 2rem
      .message
        margin-top: 6rem
</style>



// WEBPACK FOOTER //
// Error.vue?02c7b5e4